import { useEffect, useRef, useState } from 'react'
import { QRCode } from 'react-qrcode-logo'
import MoteLogoUrl from '@mote/assets/pngs/mote-round-white.png'
import styled from '@xstyled/styled-components'

export interface QRCodeDisplayProps {
  url: string
}

export function QRCodeDisplay(props: QRCodeDisplayProps) {
  const [imageSrc, setImageSrc] = useState()
  const qrCodeRef = useRef<QRCode>(null)

  useEffect(() => {
    if (qrCodeRef.current) {
      //@ts-ignore
      const { canvas } = qrCodeRef.current
      setTimeout(() => setImageSrc(canvas.current.toDataURL('image/png')), 100)
    }
  }, [props.url])

  return (
    <QRCodeContainer>
      <QRCode
        value={props.url}
        logoImage={MoteLogoUrl}
        size={150}
        ref={qrCodeRef}
        quietZone={0}
      />
      {imageSrc ? <StyledImage src={imageSrc} /> : null}
    </QRCodeContainer>
  )
}

export const QRCodeContainer = styled.div({
  width: 150,
  height: 150,
  position: 'relative'
})

export const StyledImage = styled.img({
  position: 'absolute',
  opacity: 0,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
})
